import React from "react";
import { TouchableOpacity, Image, View, StyleSheet, Platform } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import HomeScreen from "../screens/HomeScreen";
import LandingScreen from "../screens/LandingScreen";
import PackDetailScreen from "../screens/PackDetailScreen";
import LearningScreen from "../screens/LearningScreen";
import WordsScreen from "../screens/WordsScreen";
import colors from "../theme/colors";
import WordContributionScreen from "../screens/WordContributionScreen";
import { CommonActions } from "@react-navigation/native";
import CustomBottomTab from "../components/CustomBottomTab";

const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();

const HomeStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="HomeMain" component={LandingScreen} />
      <Stack.Screen name="LearningPacks" component={HomeScreen} />
    </Stack.Navigator>
  );
};

const TabNavigator = () => {
  return (
    <Tab.Navigator
      tabBar={(props) => <CustomBottomTab {...props} />}
      screenOptions={{
        headerShown: false,
      }}>
      <Tab.Screen name="HomeTab" component={HomeStack} options={{ tabBarLabel: "Home" }} />
      <Tab.Screen name="Words" component={WordsScreen} />
    </Tab.Navigator>
  );
};

const AppNavigator = () => {
  const navigation = useNavigation();
  const goToHome = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "MainTabs" }],
      })
    );
  };

  const LogoTitle = () => (
    <TouchableOpacity onPress={goToHome}>
      <Image
        style={styles.logo}
        source={require("../../assets/dark-logo.png")}
        resizeMode="contain"
      />
    </TouchableOpacity>
  );

  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerShown: true,
        headerTitle: () => <LogoTitle />,
        headerTitleAlign: "center",
        headerLeft: () => {
          if (route.name !== "MainTabs") {
            return (
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => {
                  if (navigation.canGoBack()) {
                    navigation.goBack();
                  } else {
                    goToHome();
                  }
                }}
                style={styles.backButton}>
                <Ionicons name="arrow-back" size={24} color={colors.primary} />
              </TouchableOpacity>
            );
          }
          return null;
        },
        headerStyle: {
          backgroundColor: colors.secondary,
          height: 100, // Adjust this value to match your logo's height
        },
        headerTintColor: colors.primary,
      })}>
      <Stack.Screen options={{ headerShown: false }} name="MainTabs" component={TabNavigator} />
      <Stack.Screen name="WordContribution" component={WordContributionScreen} />
      <Stack.Screen name="PackDetail" component={PackDetailScreen} />
      <Stack.Screen name="Learning" component={LearningScreen} />
    </Stack.Navigator>
  );
};

const styles = StyleSheet.create({
  logo: {
    width: 150, // Adjust this value based on your logo's dimensions
    height: 150, // Adjust this value based on your logo's dimensions
  },
  backButton: {
    marginLeft: 16,
  },
});

export default AppNavigator;
